<template>
    <div class="afu-text-center afu-text-black afu-text-base afu-leading-base afu-font-semibold afu-mt-10">
        <AfTerms :terms="getTerms" />
        <div
            v-if="$_job.terms_and_conditions"
            class="af-apply-form-disclosure"
        >
            <p v-html="$_job.terms_and_conditions" />
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import AfTerms from '@/components/Partials/AfTerms';

    export default {
        name: 'ApplyFormFooter',

        components: {
            AfTerms,
        },

        data() {
            return {};
        },

        computed: {
            ...mapState({
                $_job: state => state.job.job,
            }),

            getTerms() {
                let terms = window?.afConfig?.terms_content;
                if (terms) {
                    terms = JSON.parse(terms);
                } else {
                    terms = [];
                }
                return terms;
            },
        },

        methods: {
            ...mapMutations('jobApplication', {
                $_CHECK_RESUME_REVIEW: 'CHECK_RESUME_REVIEW',
                $_UNCHECK_RESUME_REVIEW: 'UNCHECK_RESUME_REVIEW',
            }),
        },
    };
</script>
